module.exports = __webpack_public_path__ + "static/cross-bg-0d7bd4cac661eb573d0149fe65daacb6.png";